var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"data-menu-toggle":"","icon":""},on:{"click":_vm.toggleSideMenu}},'v-btn',_vm.$props,false),[_c('img',{attrs:{"id":"burger-menu","alt":"burger-menu","src":_vm.icon,"width":"24px","height":"24px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }